import { usePrevious } from '@nf/utils-common/hooks';
import { useEffect, useRef, useState } from 'react';

export const TotalBoard = ({ totalScore }: { totalScore: string | number }) => {
	const score = totalScore as number;
	const previousPoint = usePrevious<number>(score) ?? 0;
	const [isScored, setIsScored] = useState(false);
	const timerRef= useRef<ReturnType<typeof setTimeout>>();
	useEffect(() => {
		const isPointChange = previousPoint !== Number(totalScore) 
		if (!isPointChange || previousPoint === 0) {
			return;
		}

		clearTimeout(timerRef.current);
		setIsScored(true);
		timerRef.current = setTimeout(() => {
			setIsScored(false);
		}, 3000);

		return () => {
			clearTimeout(timerRef.current);
		};

	}, [totalScore]);

	return (
		<div className="scoreboard__cell">
			<span
				className="scoreboard__text"
				data-scored={isScored}
			>
				{totalScore}
			</span>
		</div>
	);
};